import { cn } from '@/utils/tailwind';

const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('animate-pulse rounded-md bg-gr-200', className)} {...props} />;
};

export default Skeleton;
